const typography = {
  primary: `"Open Sans", Roboto, Helvetica, Arial, sans-serif`,
  sizes: {
    text: {
      lead: '18px',
      body: '16px',
      small: '14px',
    },
    heading: {
      display: '68px',
      h1: '46px',
      h2: '38px',
      h3: '28px',
      h4: '24px',
      h5: '18px',
      h6: '16px',
    },
    lineHeight: {
      display: '76px',
      h1: '54px',
      h2: '46px',
      h3: '36px',
      h4: '32px',
      h5: '26px',
      h6: '24px',
      lead: '26px',
      body: '24px',
      small: '20px',
    },
  },
  weights: {
    regular: 400,
    semiBold: 600,
    bold: 700,
    extraBold: 800,
  },
};

export { typography };
